import { getDateWithoutTimezone } from '../../utils';
import { ChartContext } from '../interface';

export const createFundsQuotaHoldersSerie = (
  quotes: ChartContext.IAssetQuotes | undefined
): Highcharts.SeriesOptionsType[] => {
  if (!quotes) return [];

  const data = quotes.quotes.map(({ d, p, q }) => ({
    date: d,
    quotaHolder: q,
    netWorth: p,
  }));

  let quotaHolderChartData: Highcharts.SeriesOptionsType[] = [];

  const quotaHolderData = {
    type: 'line' as const,
    data: new Array(data.length),
    name: 'Cotistas',
    color: quotes.color,
  };

  const midPatrimonyData = {
    type: 'line' as const,
    data: new Array(data.length),
    name: 'Patrimônio médio por cotista',
    yAxis: 1,
    color: '#0f132a',
  };

  for (let i = 0; i < data.length; i++) {
    const period = getDateWithoutTimezone(data[i].date);
    const quotaHolder = data[i].quotaHolder || 0;
    const netWorth = data[i].netWorth || 0;

    quotaHolderData.data[i] = [period, quotaHolder];

    if (quotaHolder > 0 && netWorth > 0) {
      midPatrimonyData.data[i] = [period, netWorth / quotaHolder];
    } else {
      midPatrimonyData.data[i] = [period, 0.0];
    }
  }

  quotaHolderChartData = [quotaHolderData, midPatrimonyData];

  return quotaHolderChartData;
};
